const aiCollege = [
    {
      title: '【線上自學】企業資安管理與應用系列課程',
      date: '2022/09/28',
      url: 'https://college.itri.org.tw/Home/LessonData?PosterGUID=0023200A-5524-4969-855F-1B86C63D193E'
    },
    {
      title: 'PyTorch深度學習物件偵測模型實作(從YOLOv1-v5到YOLOX)',
      date: '2022/09/21',
      url: 'https://college.itri.org.tw/Home/LessonData?PosterGUID=4849868C-0329-439B-97F5-B5D5D1187BBB'
    },
    {
      title: 'Python影像處理、電腦視覺與機器學習實作',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Home/LessonData?PosterGUID=62881099-42B2-40EE-882B-AE8E3213DDE6'
    },
    {
      title: '自然語言處理與生成式對抗網路實作',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Home/LessonData?PosterGUID=236575D6-BCD5-4BF7-8765-97B739219F48'
    },
    {
      title: 'Python數位訊號處理實作',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Home/LessonData/11FA86C9-FD2F-44C3-BB20-DEE58F2A437F'
    },
    {
      title: '機器學習工程師初級培訓班',
      date: '2022/09/19',
      url: 'https://college.itri.org.tw/Home/LessonData/B51F9AE8-1871-4440-8005-36CBA066F67E'
    },
  ]
  
  export default aiCollege;